// Framework and third-party non-ui
import React, { useState } from "react";

// Third-party components (buttons, icons, etc.)
import { makeStyles } from "@material-ui/core/styles";

import { getTrailheadFeature } from "data/map.js";
import DirectionsIcon from "@material-ui/icons/DirectionsOutlined";
import NoDirections from "./NoDirections";
import FindingDirections from "./FindingDirections";

import Point from "@arcgis/core/geometry/Point";
import * as webMercatorUtils from "@arcgis/core/geometry/support/webMercatorUtils";
import * as geodesicUtils from "@arcgis/core/geometry/support/geodesicUtils";

// const trailheadsUrl = 'https://gis.ohiodnr.gov/arcgis_site2/rest/services/OIT_Services/Ohio_DETOUR_trails_test/MapServer/0';
const googleMapDirUrl = "https://www.google.com/maps/dir"; //Example: https://www.google.com/maps/dir/41.87,-87.62/42.33,-83.04/

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    cursor: "pointer",
    flexDirection: "column",
    color: "#4D7343",
    fontFamily: "Open Sans",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.4px",
    alignItems: "center",
    marginLeft: "15px",
  },
}));

const Directions = ({ trailId, trailhead }) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const classes = useStyles();

  const handleDirections = async () => {
    let minDistance;
    let join;
    let closestTrailheadCoords;
    let distance;
    let directionsLink;
    let userLocation;
    let trailheadLngLatValues;
    let trailheadLngLatVal;
    let trailheads;

    //Trailhead POI
    setLoading(true);
    if (trailhead) {
      //Get user's current location
      userLocation = await getLocation();
      trailheadLngLatVal = webMercatorUtils.xyToLngLat(
        trailhead.geometry.x,
        trailhead.geometry.y
      );

      if (
        userLocation &&
        userLocation.coords &&
        userLocation.coords.longitude &&
        userLocation.coords.latitude
      ) {
        //Open tab with google maps directions
        directionsLink = `${googleMapDirUrl}/${userLocation.coords.latitude},${userLocation.coords.longitude}/${trailheadLngLatVal[1]},${trailheadLngLatVal[0]}`;
        window.open(directionsLink);
      } else {
        //Open tab with google maps directions(no user location specified)
        if (trailheadLngLatValues && trailheadLngLatValues.length) {
          directionsLink = `${googleMapDirUrl}//${trailheadLngLatValues[0][1]},${trailheadLngLatValues[0][0]}`;
          window.open(directionsLink);
        }
      }
      return;
    }

    trailheads = await getTrailheadFeature(trailId);

    //Get Google map directions to trailhead
    if (trailheads.features && trailheads.features.length) {
      trailheadLngLatValues = trailheads.features.map((trailhead) =>
        webMercatorUtils.xyToLngLat(trailhead.geometry.x, trailhead.geometry.y)
      );

      //Get user's current location
      userLocation = await getLocation();

      //Loop through all trailheads to find trailhead closest to user's location
      if (
        userLocation &&
        userLocation.coords &&
        userLocation.coords.longitude &&
        userLocation.coords.latitude
      ) {
        minDistance = 100000;
        trailheadLngLatValues.forEach((lngLat) => {
          join = geodesicUtils.geodesicDistance(
            new Point({
              x: userLocation.coords.longitude,
              y: userLocation.coords.latitude,
            }),
            new Point({ x: lngLat[0], y: lngLat[1] }),
            "miles"
          );
          distance = join.distance;
          if (distance < minDistance) {
            minDistance = distance;
            closestTrailheadCoords = lngLat;
          }
        });

        //Open tab with google maps directions
        directionsLink = `${googleMapDirUrl}/${userLocation.coords.latitude},${userLocation.coords.longitude}/${closestTrailheadCoords[1]},${closestTrailheadCoords[0]}`;
        window.open(directionsLink);
      } else {
        //Open tab with google maps directions(no user location specified)
        if (trailheadLngLatValues && trailheadLngLatValues.length) {
          directionsLink = `${googleMapDirUrl}//${trailheadLngLatValues[0][1]},${trailheadLngLatValues[0][0]}`;
          window.open(directionsLink);
        }
      }
    } else {
      setDialogOpen(true);
    }
    setLoading(false);
  };

  const getLocation = () => {
    return new Promise((res, rej) => {
      var geolocation = navigator.geolocation;
      geolocation.getCurrentPosition(
        (position) => {
          console.log(position);
          res(position);
        },
        (err) => {
          console.log(err);
          rej(err);
        }
      );
    });
  };

  const closeNoDirectionsHandler = () => {
    setDialogOpen(false);
  };

  return (
    <>
      <div className={classes.container} onClick={handleDirections}>
        <DirectionsIcon className={classes.iconStyle} />
        Get Here
      </div>
      <NoDirections
        dialogOpen={dialogOpen}
        closeHandler={closeNoDirectionsHandler}
      />
      <FindingDirections dialogOpen={loading} />
    </>
  );
};

export default Directions;
